import React, { useState, useEffect } from 'react';
import '../../urunDiv.css';
import '../icecekler/sicak-kahveler/KahveDetay.css';
import kasarliSucukluTost from '../../../assets/menu/yemekler/tostlar/kasarli-sucuklu-tost.jpeg';

const KasarliSucukluTost = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const yemek = {
    name: 'Kaşarlı Sucuklu Tost',
    price: '₺399,90',
    image: kasarliSucukluTost,
    description: 'Tost ekmeği arasında kaşar peyniri, sucuk, patates kızartması, çeri domates, salatalık...'
  };

  return (
    isPhone ? (
      <div className="americano-detay-container">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-detay-container-computer">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description-computer">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    )
  );
};

export default KasarliSucukluTost;
